
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Brest dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Brest certifiée Google Partner, accompagne les entreprises brestoises dans leur expansion en ligne et l'acquisition de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Brest dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Brest certifiée Google Partner, accompagne les entreprises brestoises dans leur expansion en ligne et l'acquisition de nouveaux clients.",
        },
      ],
    };
  },
};
